import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-draw-save",
  "use": "icon-draw-save-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-draw-save\"><path d=\"M24 6a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H9.368a1 1 0 0 1-.723-.31l-2.368-2.479a1 1 0 0 1-.277-.69V8a2 2 0 0 1 2-2h16Zm-5 16h-7a1 1 0 0 0-1 1v3h9v-3a1 1 0 0 0-1-1Zm3-15H10a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1Z\" /><path d=\"M14 26h-2v-2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V26Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol